export default "__VITE_ASSET__CtqjRyRb__"